module.exports = __webpack_public_path__ + "static/media/vignette_05.2ad4dc36.png";